import { api } from "@/services";
import { formatPrice } from "@/utils";

export async function getCart(id: string) {
  try {
    const { data } = await api.get(`Cart/${id}`);
    // console.log("aaaaaaaaah a data", data);
    if (data) {
      if (data.centroMontagem) {
        const cartData = {
          ...data,
          id: data.id,
          name: data.name,
          fase: data.fase,
          dateCreated: data.dateCreated,
          dateLastUpdated: data.dateLastUpdated,
          items: data.items,
          store: data.store,
          total: formatPrice(data.total),
          totalDesconto: formatPrice(data.totalDesconto),
          subTotal: formatPrice(data.subTotal),
          totalFrete: formatPrice(data.totalFrete),
          totalNumber: data.total,
          partnerId: data.centroMontagem.credenciadoId
        };

        return { cartData };
      } else {
        const cartData = {
          ...data,
          id: data.id,
          name: data.name,
          fase: data.fase,
          dateCreated: data.dateCreated,
          dateLastUpdated: data.dateLastUpdated,
          items: data.items,
          store: data.store,
          total: formatPrice(data.total),
          totalNumber: data.total,
          totalDesconto: formatPrice(data.totalDesconto),
          totalDescontoNumber: data.totalDesconto,
          subTotal: formatPrice(data.subTotal),
          subTotalNumber: data.subTotal,
          totalFrete: formatPrice(data.totalFrete),
          totalFreteNumber: data.totalFrete
        };

        return { cartData };
      }
    } else {
      const cartData = null;

      return { cartData };
    }
  } catch (error) {
    const cartData = null;
    return { cartData };
  }
}

// TODO: remove totalnumber
// TODO: include coupon obeject

// "cupom": {
//   "couponId": "cupomCelso",
//   "couponDesc": "5% de desconto",
//   "discount": 5
// },
